import { v4 as uuid } from 'uuid';
import type { ChipModelDto } from '@/schemas/chip';

/** A new adapter definition owns independent identities; editing drafts do not. */
export function rekeyBundleAdapterSignals(dto: ChipModelDto): void {
  if (dto.kind !== 'bundle-adapter') return;
  const replacements = new Map<string, string>();
  dto.adapterSignals = Object.fromEntries(
    Object.entries(dto.adapterSignals ?? {}).map(([label, previous]) => {
      let replacement = replacements.get(previous);
      if (!replacement) {
        replacement = `adapter:${dto.id}:${uuid()}`;
        replacements.set(previous, replacement);
      }
      return [label, replacement];
    }),
  );
  for (const link of dto.interfaceLinks) {
    if (!link.selectorSignalIds) continue;
    link.selectorSignalIds = link.selectorSignalIds.map((previous) => {
      let replacement = replacements.get(previous);
      if (!replacement) {
        replacement = `adapter:${dto.id}:${uuid()}`;
        replacements.set(previous, replacement);
      }
      return replacement;
    });
  }
}
